// extracted by mini-css-extract-plugin
module.exports = {"AddQuoteSegmentCard":"PageNewQuote_AddQuoteSegmentCard__sk6bf"};